// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';

// app modules: components
import Link from 'components/Link';
import Heading from 'components/Heading';
import { UnorderedList, ListItem } from 'components/List';

// app modules: actions
import { getSearchExamples } from 'actions/search';

// app modules: props
import SearchExamplesProps from './SearchExamplesProps';

// assets
import CssSearchExamples from './SearchExamples.scss';

class SearchExamples extends Component {
  static propTypes = {
    examples: SearchExamplesProps.examples,
    getSearchExamples: PropTypes.func.isRequired,
  };

  static defaultProps = {
    examples: [],
  };

  componentDidMount() {
    const { examples } = this.props;
    if (!examples || !examples.length) {
      this.props.getSearchExamples();
    }
  }

  renderExamples() {
    const { examples } = this.props;

    return examples.map(example => {
      const key = `search-example-${example.display_index}`;

      return (
        <ListItem className="search-examples__item" key={key}>
          <Link to={example.url} className="search-examples__link">
            {example.text}
          </Link>
        </ListItem>
      );
    });
  }

  render() {
    return (
      <div className="search-examples">
        <Heading>Some searches to try:</Heading>
        <UnorderedList
          className="list--dashed list--dashed-dusty-gray"
          vertical
          spaceBetween="none"
        >
          {this.renderExamples()}
        </UnorderedList>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  examples: state.search.examples.items,
});

const mapDispatchToProps = {
  getSearchExamples,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(CssSearchExamples)(SearchExamples));
